import { head } from 'lodash';
import { FC, useEffect, useState } from 'react';

import { Box, Loader } from '@qwealth/qcore';

import ClientNotesHistoryNoteCard from '../Common/NotesHistory/ClientNotesHistoryNoteCard';
import { useAppDispatch, useAppSelector } from 'data/store';
import { ComplianceNote } from 'data/models/Compliance';
import { getClientNotesHistory } from 'data/actions/compliance';
import { sortNotesHistoryByDate } from 'utils/ComplianceUtil';

interface Props {
  contactQID: string | undefined;
}

const MessagesNotesHistorySection: FC<Props> = ({ contactQID }): JSX.Element => {
  const dispatch = useAppDispatch();
  const [note, setNote] = useState<ComplianceNote>();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    if (!contactQID) return;
    (async () => {
      const notesFromApi = await dispatch(getClientNotesHistory(contactQID));

      if (!notesFromApi) {
        setIsLoading(false);
        return;
      }

      const note = head(
        sortNotesHistoryByDate(notesFromApi).filter(note => {
          if ('itemId' in note) {
            return note.itemId === -1;
          } else {
            return false;
          }
        }),
      );

      if (note) setNote(note as ComplianceNote);
      setIsLoading(false);
    })();
  }, [contactQID, dispatch]);

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <Loader />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" overflow="auto" paddingBottom="large">
      {note ? (
        <ClientNotesHistoryNoteCard note={note} />
      ) : (
        <Box display="flex" justifyContent="center" alignItems="center">
          No message to display.
        </Box>
      )}
    </Box>
  );
};

export default MessagesNotesHistorySection;
